// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarCMS_sidebar__t4pJm","card":"SidebarCMS_card__AxG2D","downloadAppTitle":"SidebarCMS_downloadAppTitle__s6TtN"};